import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { AuthProvider } from '@/lib/auth'
import { Toaster } from '@/components/ui/sonner'
import '@/lib/i18n'

// RLS/auth/shape errors (42501, PGRST*) can never succeed on retry — don't
// burn requests on them. Everything else gets up to 2 attempts.
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (failureCount >= 2) return false
  const code = (error as { code?: string; status?: number } | null)?.code
  if (code && ['42501', 'PGRST301', 'PGRST302', 'PGRST116'].includes(code)) return false
  return true
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false, retry: shouldRetry },
  },
})

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>{children}</AuthProvider>
      <Toaster richColors position="top-center" />
    </QueryClientProvider>
  )
}